import React, { useEffect, useState } from "react";
import Edit_Non_Work from "./edit_Complaints/Edit_Complaints";
import Non_Work_Form from "./complaints_Form/Complaints_Form";
import Non_Work_table from "./complaints_table/Complaints_table";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Edit_Complaints from "./edit_Complaints/Edit_Complaints";
import Complaints_Form from "./complaints_Form/Complaints_Form";
import Complaints_table from "./complaints_table/Complaints_table";
import {
  Create,
  GetAll,
  Update,
  Delete,
} from "../../../../../../../src/features/admin/quality_management/process_requirement/complaint/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";
import Delete_offcanvas from "../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";

function Complaints() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const complaintsdetails = useSelector((state) => state.complaint);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const handleEdit = (id) => {
    setEditId(id);
    setIsEdit(true);
  };

 const handleDelete = async () => {
  if (!selectedDeleteId) return;

  try {
    await dispatch(Delete(selectedDeleteId)).unwrap();

    fetchCustomers(currentPage); //  refresh table
    //setDelete(false);            //  close offcanvas
    setSelectedDeleteId(null);   // reset
  } catch (err) {
    console.error("Delete failed", err);
    alert("Delete failed");
  }
};



  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: complaintsdetails.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.complaint.List);
  const haveEditPermission = permissions?.includes(FixIDS.complaint.Edit);
  const haveAddPermission = permissions?.includes(FixIDS.complaint.Add); //form
  const haveDeletePermission = permissions?.includes(FixIDS.complaint.Delete,);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Edit Complaints" />
          </div>
          {haveEditPermission && <Edit_Complaints id={editId} onCancel={() => setIsEdit(false)} />}
        </>
      ) : (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Complaints" />
          </div>

          <div className="imperiality_Form_div">
            {haveAddPermission && <Complaints_Form />}
          </div>

          {/* <div className="imperiality_table_div">
            { haveReadPermission && <Complaints_table
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              complaintsdetails={complaintsdetails}
              onEdit={handleEdit}
            />}
          </div> */}
          <div className="imperiality_table_div">
            <Complaints_table
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              complaintsdetails={complaintsdetails}
              onEdit={haveReadPermission ? handleEdit : null}
              ondelete={haveDeletePermission ? (id) => {
                setSelectedDeleteId(id);
                setDelete(true);  // open delete popup
              } : null}
            />
          </div>
        </>
      )}

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Complaint"
          massageText={"Complaint"}
        />
      )}

    </section>
  );
}

export default Complaints;
